export default {
      id: "reefer-mode-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "img/icons.svg#reefer-mode",
      toString: function () {
        return this.url;
      }
    }